'use strict';

require("core-js/modules/esnext.string.replace-all.js");
Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["accept", "maxSizeLabel"];
/**
 * Type and size information
 * Displays the accepted file types and the maximum file size of an input.
 */
var TypeAndSizeLabel = function TypeAndSizeLabel(_ref) {
  var accept = _ref.accept,
    maxSizeLabel = _ref.maxSizeLabel,
    rest = _objectWithoutProperties__default["default"](_ref, _excluded);
  if (!accept && !maxSizeLabel) {
    return null;
  }

  /*
   * Note: `accept` does not only accept MIME types with file endings,
   * but also MIME types describing file type groups like `application/msword`.
   *
   * If that is ever the case, we should introduce a new prop like
   * `acceptLabel` or separate this info text into another component.
   */
  var label = [accept && accept.split(',').map(function (type) {
    return type.trim();
  }).map(function (type) {
    var _type$split;
    return ((_type$split = type.split('/')) === null || _type$split === void 0 ? void 0 : _type$split[1]) || type;
  }).join(', ').replaceAll('.', '').toUpperCase(), maxSizeLabel && "(".concat(maxSizeLabel, ")")].filter(Boolean).join(' ');
  return /*#__PURE__*/React__default["default"].createElement(react.Text, _extends__default["default"]({
    display: "block",
    as: "span",
    mb: 2,
    color: "gray.400",
    fontSize: "sm"
  }, rest), label);
};
exports.TypeAndSizeLabel = TypeAndSizeLabel;